import * as React from 'react';
import CallbackHelpers from '../helpers/CallbackHelpers';
import {AutomaticDatasetResponseFilter} from '../types/AutomaticDatasetResponseFilter';
import {AutomaticDataset} from '../../reports/types/AutomaticDataset';

export interface AutomaticDatasetResponseCacheProps {
  getAutomaticDatasetResponse: (filter: AutomaticDatasetResponseFilter) => AutomaticDataset;
  clearAutomaticDatasetResponseCache: (key?: AutomaticDatasetResponseFilter) => void;
  getResponseKey: (key?: string) => AutomaticDatasetResponseFilter;
  isAutomaticDatasetResponseCacheProcessing: boolean;
}

export const AutomaticDatasetResponseCache = React.createContext<AutomaticDatasetResponseCacheProps>({
  getAutomaticDatasetResponse: CallbackHelpers.ThrowNotImplemented,
  clearAutomaticDatasetResponseCache: CallbackHelpers.NoOp,
  getResponseKey: CallbackHelpers.ThrowNotImplemented,
  isAutomaticDatasetResponseCacheProcessing: false
});